module.exports = window[Symbol.for('@ally/federator')].modules.get('ally-next-remote-header').externals.get("react");